import { render } from "./mCdetail.vue?vue&type=template&id=4d299a36&scoped=true"
import script from "./mCdetail.vue?vue&type=script&lang=js"
export * from "./mCdetail.vue?vue&type=script&lang=js"

import "./mCdetail.vue?vue&type=style&index=0&id=4d299a36&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d299a36"]])

export default __exports__